import { useQuery } from 'react-query'
import { api } from '../../../utils/api'
import { Transaction } from '../transaction/transaction-typed'
import { DcaList, DcaPlans, Port, TransactionsDcaPlanList } from './dca-typed'

export const DCA_URL = `internal/dcas`

export const useGetDcas = (params?: { q?: string; page?: number }) => {
  return useQuery(
    [DCA_URL, params],
    async () => {
      const datas = await api.savvyGold.get<DcaList>(DCA_URL, {
        page: params?.page,
        limit: 10,
        q: params?.q,
      })

      return datas.data.data
    },
    {
      keepPreviousData: true,
    },
  )
}

export const useGetDca = (id: string) => {
  return useQuery(
    [DCA_URL, id],
    async () => {
      const data = await api.savvyGold.get<DcaPlans>(`${DCA_URL}/${id}`)
      return data.data.data
    },
    {
      enabled: !!id,
    },
  )
}

export const useGetTransactionDcaByDcaRef = (refId: string, params: {  page: number }) => {
  return useQuery(
    [DCA_URL, refId, 'transactions', params],
    async () => {
      const data = await api.savvyGold.get<TransactionsDcaPlanList>(`${DCA_URL}/${refId}/transactions`, {
        page: params.page,
        limit: 10
      })
      return data.data.data
    },
    {
      enabled: !!refId,
    },
  )
}
